module.exports = __webpack_public_path__ + "media/images/faces/face22-61ebbccfbeeb1d1e5f76edc646e5bc06.jpg";